import React from 'react';
import {Container} from "reactstrap";
import Tabs from "./Tabs";

function OurServices() {
    return (
        <div style={{ paddingBottom: '100px' }}>
            <Container>
                <Tabs />
            </Container>
        </div>
    );
}

export default OurServices;
